<template>
  <div id="app">
    <router-view name="a" />
    <!-- <modal-scharff-real-plaza id="modalScharffRealPlaza" /> -->
    <modal-quoter-home />
    <ProductMarketFitSurvey :serviceType="serviceType" />
    <ModalCompleteData />
  </div>
</template>

<script>
import ModalQuoterHome from "./views/modals/ModalQuoterHome.vue";
import ModalScharffRealPlaza from "@/components/Modals/ModalScharffRealPlaza.vue";
import ProductMarketFitSurvey from "./views/modals/ProductMarketFitSurvey.vue";
import ModalCompleteData from "./views/modals/ModalCompleteData.vue"

/* eslint-disable no-undef */
export default {
  name: "App",
  components: {
    ModalQuoterHome,
    ModalScharffRealPlaza,
    ProductMarketFitSurvey,
    ModalCompleteData,
  },
  mounted() {
    const script = document.createElement("script");
    const mapsApiKey = process.env.VUE_APP_MAPS_API_KEY;
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}&libraries=places`;
    document.head.appendChild(script);
    script.onload = () => {
    };

    this.$nextTick(() => {
      this.initTabs();
    });

  },
  updated() {},
  computed: {
    serviceType() {
      return this.$store.getters.SERVICE_TYPE_FOR_SURVEY;
    },
  },
};
</script>

<style lang="scss"></style>
